import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AcceptInvite from "./pages/AcceptInvite";

function Gate() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Check if this is demo mode
  const searchParams = new URLSearchParams(location.search);
  const isDemoMode = searchParams.get('demo') === 'true';

  if (loading) return <div className="p-6">Loading…</div>;

  return (
    <Routes>
      {/* Root: if logged in, send to dashboard; else show landing */}
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} />

      {/* Public: accept invite (no auth needed) */}
      <Route path="/invite/accept" element={<AcceptInvite />} />

      {/* Protected: dashboard (admin vs brand member) */}
      {/* MODIFIED: Allow demo mode OR authenticated users */}
      <Route
        path="/dashboard/*"
        element={
          user || isDemoMode
            ? (user?.role === "admin" ? <AdminDashboard /> : <Dashboard />)
            : <Navigate to="/" replace state={{ from: location }} />
        }
      />

      {/* 404 → home (adjust if you add a NotFound page) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Gate />
      </BrowserRouter>
    </AuthProvider>
  );
}